enum TextVariableType {
  Variable = 0,
  Still = 1,
  CTA = 2,
}

export default TextVariableType;
